// Ícones de linha da tela de Pagamentos (decorativos: aria-hidden)
const DESENHOS = {
  carteira: <><rect x="3" y="5" width="18" height="15" rx="3" /><path d="M3 9h18m-5 5h2M7 5V3h10v2" /></>,
  chave: <><circle cx="8" cy="15" r="4" /><path d="m11 12 9-9m-3 3 3 3m-6 0 2 2" /></>,
  recibo: <><path d="M6 3h12v18l-3-2-3 2-3-2-3 2V3Z" /><path d="M9 8h6M9 12h6" /></>,
  voltar: <><path d="M9 14 4 9l5-5" /><path d="M4 9h11a5 5 0 0 1 0 10h-3" /></>,
  alerta: <><path d="M12 3 2 20h20L12 3Z" /><path d="M12 10v4m0 3h.01" /></>,
  escudo: <><path d="m12 3 8 3v6c0 5-8 9-8 9s-8-4-8-9V6l8-3Z" /><path d="m8 12 3 3 5-6" /></>,
  seta: <><path d="M5 12h14m-5-5 5 5-5 5" /></>,
  pix: <><path d="m12 3 9 9-9 9-9-9 9-9Z" /><path d="m7 8 5 5 5-5M7 16l5-5 5 5" /></>,
  maquininha: <><rect x="6" y="2" width="12" height="20" rx="3" /><path d="M9 6h6v4H9zM9 14h.01M12 14h.01M15 14h.01M9 17h.01M12 17h.01M15 17h.01" /></>,
};

export function Icone({ nome, ...props }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false" {...props}>
      {DESENHOS[nome]}
    </svg>
  );
}
